import { render, staticRenderFns } from "./indexNewsList.vue?vue&type=template&id=2bf47fea&scoped=true&"
import script from "./indexNewsList.vue?vue&type=script&lang=js&"
export * from "./indexNewsList.vue?vue&type=script&lang=js&"
import style1 from "./indexNewsList.vue?vue&type=style&index=1&id=2bf47fea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf47fea",
  null
  
)

export default component.exports